import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import Copy, { CopyProps } from 'Src/components/Copy';

interface CheckDurationTimeProps extends Omit<CopyProps, 'children' | 'color'> {
  checkCreatedTimeMilli: number | undefined;
  checkClosedTimeMilli: number | undefined;
}

const CheckDurationTime: FC<CheckDurationTimeProps> = ({
  checkCreatedTimeMilli,
  checkClosedTimeMilli,
  ...rest
}) => {
  const { t } = useTranslation();
  // Should calculate the duration between created time and closed time if closed time exists
  let initialHours: number | undefined = 0;
  let initialMinutes: number | undefined = 0;
  // timeMilli is the difference between closed time and created time
  let timeMilli: number | undefined = undefined;
  if (checkClosedTimeMilli && checkCreatedTimeMilli) {
    timeMilli = checkClosedTimeMilli - checkCreatedTimeMilli;
    const duration = DateTime.fromMillis(checkClosedTimeMilli)
      .diff(DateTime.fromMillis(checkCreatedTimeMilli), ['hours', 'minutes'])
      .toObject();
    initialHours = duration.hours ? Math.floor(duration.hours) : 0;
    initialMinutes = duration.minutes ? Math.floor(duration.minutes) : 0;
  }


  const [hoursMinutes, setHoursMinutes] = useState<{hours: number, minutes: number}>({ hours: initialHours ?? 0, minutes: initialMinutes ?? 0 });


  useEffect(() => {
    const intervalId = setInterval(() => {
      let minutes: number | undefined = 0;
      let hours: number | undefined = 0;
      // guard for quick return
      // check if value exists instead of casting to avoid runtime errors
      if (!timeMilli) return { hours, minutes };

      const time = DateTime.fromMillis(timeMilli).toObject();
      hours = time.hour ? Math.abs(Math.round(time.hour)) : 0;
      minutes = time.minute ? Math.abs(Math.round(time.minute)) : 0;

      setHoursMinutes({ hours, minutes });
    }, 1000 * 60);

    // disposal
    return () => {
      // stop interval when the component unmounts and when `timeMilli` changes
      clearInterval(intervalId);
    };
  }, [timeMilli]);

  return (
    <Copy
      color="secondary"
      value={t('check.labels.fromDate', { hours: hoursMinutes.hours, minutes: hoursMinutes.minutes })}
      {...rest}
    />
  );
};

export { CheckDurationTime };
